import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { RevealDirective } from './directives/reveal.directive';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HeroComponent } from './components/hero/hero.component';
import { FeaturesComponent } from './components/features/features.component';
import { HowComponent } from './components/how/how.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { WhyComponent } from './components/why/why.component';
import { CtaComponent } from './components/cta/cta.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { FeaturesPageComponent } from './pages/features/features.component';

@NgModule({
  declarations: [
    App,
    RevealDirective,
    NavbarComponent,
    HeroComponent,
    FeaturesComponent,
    HowComponent,
    PricingComponent,
    WhyComponent,
    CtaComponent,
    FooterComponent,
    HomeComponent,
    FeaturesPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FontAwesomeModule
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideClientHydration(withEventReplay())
  ],
  bootstrap: [App]
})
export class AppModule { }
